<template>
  <div class="page" :style="bgStyle">
    <div class="video-layout">

      <!-- Player de video o foto -->
      <div class="media-container">
        <video
          v-if="modo === 'video'"
          ref="videoPlayer"
          class="media-player"
          controls
          :poster="inicioPoster"
          preload="metadata"
          @ended="videoTerminado = true"
        >
          <source src="/mexa/video.mp4" type="video/mp4" />
          Tu navegador no soporta video HTML5.
        </video>

        <img
          v-else
          src="/mexa/foto-convencion.jpeg"
          class="media-player"
          alt="Convención Comercial 2026"
        />

      </div>

      <!-- Marca bar solo móvil -->
      <div class="marcas-bar">
        <span>XIAOMI</span>
        <span>OPPO</span>
        <span>HONOR</span>
      </div>

      <!-- Botones de acción -->
      <div class="acciones">
        <a v-if="modo === 'video'" href="/mexa/video-sin-audio.mov" download="convencion2026.mov">
          <img src="/mexa/boton-descarga-video.png" class="btn-accion" alt="Descargar video" />
        </a>
        <img
          src="/mexa/boton-regresar.png"
          class="btn-accion"
          alt="Regresar"
          @click="$router.push('/')"
        />
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoFotoView',
  props: {
    modo: { type: String, default: 'video' }
  },
  data() {
    return {
      videoTerminado: false,
      inicioPoster: '/mexa/inicio-video.jpg',
      isMobile: window.innerWidth <= 768
    }
  },
  computed: {
    bgStyle() {
      const img = this.isMobile ? '/mexa/fondo-movil.jpg' : '/mexa/fondo-video.jpg'
      return {
        backgroundImage: `url(${img})`,
        backgroundSize: 'cover',
        backgroundPosition: this.isMobile ? 'top center' : 'center 35%',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#009fe3'
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth <= 768
    }
  }
}
</script>

<style scoped>
.page {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 12vh 16px 32px;
  width: 100%;
  max-width: 760px;
}

/* ====== MEDIA ====== */
.media-container {
  width: 100%;
  background: #000;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 40px rgba(0,0,0,0.4);
}

.media-player {
  width: 100%;
  max-height: 42vh;
  object-fit: cover;
  display: block;
}

/* ====== BOTONES ====== */
.acciones {
  display: flex;
  gap: 20px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}

.btn-accion {
  height: clamp(44px, 6vw, 60px);
  width: auto;
  cursor: pointer;
  transition: transform 0.15s, filter 0.15s;
}
.btn-accion:hover {
  transform: scale(1.05);
  filter: brightness(1.1);
}
.btn-accion:active { transform: scale(0.97); }

/* Barra marcas - solo visible en móvil */
.marcas-bar {
  display: none;
}

/* ====== TABLET ====== */
@media (max-width: 1024px) {
  .video-layout { max-width: 600px; }
}

/* ====== MOBILE ====== */
@media (max-width: 768px) {
  .video-layout  { padding: clamp(200px, 45vh, 320px) 12px 28px; gap: 14px; max-width: 100%; }
  .media-player  { max-height: 54vw; }
  .acciones      { flex-direction: column; gap: 12px; align-items: center; }
  .btn-accion    { height: 50px; }

  .marcas-bar {
    display: flex;
    justify-content: center;
    gap: 28px;
    width: 100%;
    padding: 10px 0;
  }
  .marcas-bar span {
    color: #fff;
    font-size: 13px;
    font-weight: bold;
    letter-spacing: 1px;
    font-family: TelefonicaRegular, sans-serif;
  }
}
</style>
